import { faChevronDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Box from "@mui/material/Box"
import { SxProps, Theme } from "@mui/material/styles"
import { ReactNode } from "react"

const SX: SxProps<Theme> = {
    backgroundColor: "transparent",
    "&::before": { display: "none" },
    "& .MuiAccordionSummary-root": { padding: 0, minHeight: "unset", "&.Mui-expanded": { minHeight: "unset" } },
    "& .MuiAccordionSummary-content": { margin: 0, "&.Mui-expanded": { margin: 0 } },
    "& .MuiAccordionDetails-root": { padding: 0, paddingTop: "12px" },
}

/**
 * A collapsible card — the SectionAccordion ContractorBoqSection keeps privately, on the
 * same stats-card surface, so check-sheet sections fold the way BOQ sections do.
 */
const SectionAccordion = ({
    header,
    children,
    defaultExpanded = false,
}: {
    header: ReactNode
    children: ReactNode
    defaultExpanded?: boolean
}) => (
    <Box className="stats-card">
        <Accordion defaultExpanded={defaultExpanded} disableGutters elevation={0} sx={SX}>
            <AccordionSummary expandIcon={<FontAwesomeIcon icon={faChevronDown} size="sm" />}>
                <Box display="flex" alignItems="center" gap="8px" flex={1} flexWrap="wrap">
                    {header}
                </Box>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    </Box>
)

export default SectionAccordion
